<template>
  <div style="background: #718fff" class="flex-col-center">
    <el-carousel class="smart_carousel" style="background: #718fFf"
                 :height="banner_height+'px'" :autoplay="false"  indicator-position="outside">
      <el-carousel-item>
        <video autoplay="autoplay" loop="loop" id="vedio1" style="width:100%">
          <source src="../../assets/video.mp4" type="video/mp4"/>
        </video>
        <i class="iconfont" :class="muted?'icon-laba':'icon-laba1'"
           style="position:absolute;top:100px;left:20px;font-size:80px;color:#718fff"
           @click="function(){muted=!muted;music.muted = muted}"></i>
      </el-carousel-item>
      <el-carousel-item >
        <div class="banner flex-col-center">
          <div class="banner-item flex-space-between">
            <div class="slogen">
              <p>让智能化更简单</p>
              <p style="color:#000">弱电系统集成，智能化综合方案解决商</p>
              <!--<button class="jump-demo" style="background: #fff;color:#4a5de4">体验demo</button>-->
              <!--<button class="jump-demo">观看视频</button>-->
            </div>
            <div class="banners">
              <img class="banner-gif" src="../../assets/banner_foot.gif"/>
              <img class="banner-gif" src="../../assets/banner.png"/>
              <img class="banner-gif" src="../../assets/banner_top.gif"/>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="application">
      <p class="app-title">
        一站式弱电服务平台
      </p>
      <el-collapse class="app-collapse" v-model="activeName" accordion>
        <el-collapse-item class="" v-for="(item,index) in application" :key="index">
          <template slot="title">
            <img class="app-item-img" :src="item.img"/>
            <span>{{item.itemName}}</span>
          </template>
          <component v-bind:is="item.render" @comment="about">
          </component>
        </el-collapse-item>
      </el-collapse>
      <ul class="app-list flex-center" style="height:100%;margin-top:50px;">
        <li v-for="(item,index) in application"
            @click="()=>{activeIndex=index}"
            class="flex-col-center app-item">
          <img class="app-item-img" :src="activeIndex==index?item.img:item.img_normal"/>
          <span :style="{'color':activeIndex==index?'#e83439':'#fff'}">{{item.itemName}}</span>
          <div class="app-item-con" v-if="activeIndex==index">
            <p class="connect"></p>
            <div class="app-item-detail flex-center">
              <component v-bind:is="item.render" @comment="about">
              </component>
            </div>
          </div>
          <p class="app-blank" v-else style="height:30px"></p>
        </li>
      </ul>
    </div>
    <div class="content con-posit">
      <p class="app-title" style="padding:100px 0 ">
        行业智能化
      </p>
      <div class="content-item flex-space-between">
        <div class="con-info">
          <p>园区智能化</p>
          <p>智慧园区充分运用IoT、云计算、大数据、人工智能等先进技术，以“智能化+数字化+生态化”为核心规划理念，打通产业链，完善服务链，丰富配套链，构建三链合一的智慧园区产业生态圈，实现园区、企
            业、服务机构等协同发展，互惠共赢。
          </p>
          <button class="con-info-detail" @click="about">联系我们</button>
        </div>
        <div class="con-img">
          <img src="../../assets/dongcha.png"/>
          <img src="../../assets/dongcha.gif"/>
        </div>
      </div>
      <div class="content-item flex-space-between">
        <div class="con-img">
          <img src="../../assets/jiefang.png"/>
          <img src="../../assets/jiefang.gif"/>
        </div>
        <div class="con-info ta">
          <p>学校智能化</p>
          <p>智慧校园通常由以传感器网络及智能硬件为核心的校园基础设施和部署在数据中心内云端服务器上的智慧化软件系统构成，常见功能可分为智慧教学环境、智慧教学资源、智慧校园管理、智慧校园服务四大板块。</p>
          <button class="con-info-detail" @click="about">联系我们</button>
        </div>
      </div>
      <div class="content-item flex-space-between">
        <div class="con-info">
          <p>医院智能化</p>
          <p>智慧医院则基于BIM、VR、数字孪生等技术，为医疗院区进行数字化集成升级与优化，建成BIM运维+数字孪生可视化技术的医院智能化集成系统，实现三维场景下医院的安全保障，减少了人力成本、降低了能耗成本、节约了管理成本。</p>
          <button class="con-info-detail" @click="about">联系我们</button>
        </div>
        <div class="con-img">
          <img src="../../assets/wajue.png"/>
          <img src="../../assets/wajue.gif"/>
        </div>
      </div>
    </div>
    <div class="partner" style="padding:20px 0">
      <p class="app-title" style="color:#101010;font-size:24px;height:60px;padding-top:20px; font-weight: 500">
        合作伙伴
      </p>
      <div class="flex-center" style="height:230px">
        <img class="part-logo-big" src="../../assets/partner/yidong.png"/>
        <img class="part-logo-big" src="../../assets/partner/huawei.png"/>
        <img class="part-logo" src="../../assets/partner/dahua.png"/>
        <img class="part-logo" src="../../assets/partner/H3C.png"/>
        <img class="part-logo" src="../../assets/partner/datangdianxin.png"/>
        <!--<img class="part-logo" src="../../assets/wanda.png"/>-->
      </div>
    </div>
  </div>
</template>

<script>
  import app1 from './block/app1'
  import app2 from './block/app2'
  import app3 from './block/app3'
  import app4 from './block/app4'
  export default {
    name: "smart_mall",
    components:{app1,app2,app3,app4},
    data() {
      return {
        activeName:'1',
        activeIndex: 0,
        banner_height:1080/1920*document.body.clientWidth,
        music:{},
        muted:true,
        application: [
          {
            itemName: '弱电系统集成',
            img:require('../../assets/app3.png'),
            img_normal:require('../../assets/app3_normal.png'),
            path:'app1',
            render: app1,
          },
          {
            itemName: '建筑智能化',
            img:require('../../assets/app2.png'),
            img_normal:require('../../assets/app2_normal.png'),
            path:'app2',
            render: app2
          },
          {
            itemName: '智能软件开发',
            img:require('../../assets/app4.png'),
            img_normal:require('../../assets/app4_normal.png'),
            path:'app3',
            render: app3
          },
          /*{
            itemName: '5G时代，免硬件免维护的小基站',
            img:require('../../assets/app1.png'),
            img_normal:require('../../assets/app1_normal.png'),
            path:'app4',
            render: app4
          }*/
        ]
      }
    },
    mounted(){
      this.music = document.getElementById("vedio1");
      this.music.muted = this.muted
      this.music.play();

      // this.banner_height = 1080/1920*document.body.clientWidth
      // this.$store.state.keepAlive.push('smart_mall')
    },
    methods:{
      about(){
        this.$router.push({
          path:'/about'
        })
      },
      intent(path) {
        this.$router.push({
          path
        })
      },
    }
  }
</script>

<style scoped>
  @import "../../style.css";
  @import "smart_mall_pc.css";
  @import "smart_mall_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/smart_mall/smart_mall.vue